/* eslint-disable react/no-array-index-key */
import React, { ChangeEvent, useEffect, useState, useContext } from 'react';

import {
  InpuTypeString,
  FilterContainer,
  FilterHeader,
  FilterTitle,
  FilterTitleRow,
  ConditionDropdown,
  FilterRow,
  BetweenLabel,
  FullWidthButton,
} from './styles';
import { FilterContext } from '~/context/filter';
import { useFiltro } from '../../FiltroContext';
import { transformAsCurrency } from '~/utils/functions';
import { moedaFormatada } from './formatMask';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

const options = [
  {
    description: 'Igual à',
    cod_condicao: 0,
  },
  {
    description: 'Maior ou igual à',
    cod_condicao: 1,
  },
  {
    description: 'Maior que',
    cod_condicao: 9,
  },
  {
    description: 'Menor ou igual à',
    cod_condicao: 2,
  },
  {
    description: 'Menor que',
    cod_condicao: 10,
  },
  {
    description: 'Diferente de',
    cod_condicao: 3,
  },
  {
    description: 'Entre',
    cod_condicao: 6,
  },
  {
    description: 'Preenchido',
    cod_condicao: 7,
  },
  {
    description: 'Não Preenchido',
    cod_condicao: 8,
  },
];

const TypeDecimal: React.FC = () => {
  // Condições
  const entre = 6;
  const preenchido = 7;
  const naoPreenchido = 8;

  const {
    searchOnClick,
    isFilterBlock,
    handleSetNewValue,
    filter,
    removeFilter,
  } = useFiltro();

  const [isMulti, setMulti] = useState<boolean>(false);
  const [Mask, setMask] = useState<string>('');
  const [value, setValue] = useState<number | string>(
    Array.isArray(filter.des_valor) ? filter.des_valor[0] : filter.des_valor,
  );
  const [value2, setValue2] = useState<number | string>(
    Array.isArray(filter.des_valor) ? filter.des_valor[1] : filter.des_valor,
  );
  const [condition, setCondition] = useState(filter.condicao);
  const { RemoveFilterEmptyByIndex } = useContext(FilterContext);

  useEffect(() => {
    handleSetValueFiltro();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchOnClick]);

  useEffect(() => {
    if (filter.tipo_expressao === 1) {
      if (filter.listagem_info) {
        const maskExp = JSON.parse(filter.listagem_info);
        setMask(maskExp[0].valor);
      }
    }
  }, [
    filter.tipo_expressao,
    filter.listagem_info,
    value,
    filter.expressao_validacao,
    filter.condicao,
  ]);

  useEffect(() => {
    if (condition === entre) {
      setMulti(true);
    } else {
      setMulti(false);
    }
  }, [condition]);

  const handleDesValor = () => {
    if (condition === preenchido || condition === naoPreenchido) {
      return undefined;
    }
    if (condition === entre) {
      return [transformAsCurrency(value), transformAsCurrency(value2)];
    }
    return transformAsCurrency(value);
  };

  const handleSetValueFiltro = () => {
    if (ValidateInputs()) {
      if (!isFilterBlock) RemoveFilterEmptyByIndex(filter.index);
      return;
    }

    const Value = handleDesValor();
    handleSetNewValue({
      index: filter.index,
      des_nome: filter.des_nome,
      nome_bd: filter.nome_bd,
      condicao: condition,
      des_valor: Value,
      cod_tipo_dados: filter.cod_tipo_dados,
      cod_tipo_info: filter.cod_tipo_info,
      cod_campo: filter.cod_campo,
      isBlock: isFilterBlock,
      expressao_validacao: filter.expressao_validacao,
      listagem_info: filter.listagem_info,
      tipo_expressao: filter.tipo_expressao,
    });
  };

  const ValidateInputs = () => {
    if (condition === naoPreenchido || condition === preenchido) {
      return false;
    }

    let val = value;
    let val2 = value;

    if (value && typeof value !== 'number') {
      val = transformAsCurrency(value);
    }
    if (value2 && typeof value2 !== 'number') {
      val2 = transformAsCurrency(value2);
    }

    if (
      !(condition === entre
        ? Number(val) >= 0 && Number(val2) >= 0
        : Number(val) >= 0 && val !== '' && val2 !== '')
    ) {
      return true;
    }
    return false;
  };

  function onChangeInput(event: ChangeEvent<HTMLInputElement>) {
    const valueInput = event.target.value;
    const ValidarCarecteresEspeciais = /\W|_/;

    let valor = '';
    if (Mask) {
      for (let i = 0; i < valueInput.length; i++) {
        const splitMask = Mask.split(',');

        if (splitMask[1]) {
          if (splitMask[1].length === 3) {
            const serializedValue = moedaFormatada(valueInput, 3);
            setValue(serializedValue);
            return;
          }

          if (splitMask[1].length === 2) {
            const serializedValue = moedaFormatada(valueInput, 2);
            setValue(serializedValue);
            return;
          }
        }

        if (ValidarCarecteresEspeciais.test(Mask[i])) {
          valor += Mask[i];
          valor += valueInput[i].replace(/[^0-9]/g, '') || '';
        } else {
          valor += valueInput[i].replace(/[^0-9]/g, '') || '';
        }
      }

      setValue(valor);
      return;
    }
    setValue(valueInput);
  }
  function onChangeInput2(event: ChangeEvent<HTMLInputElement>) {
    const valueInput = event.target.value;
    const ValidarCarecteresEspeciais = /\W|_/;

    let valor = '';
    if (Mask) {
      for (let i = 0; i < valueInput.length; i++) {
        const splitMask = Mask.split(',');

        if (splitMask[1]) {
          if (splitMask[1].length === 3) {
            const serializedValue = moedaFormatada(valueInput, 2);
            setValue2(serializedValue);
            return;
          }

          if (splitMask[1].length === 2) {
            const serializedValue = moedaFormatada(valueInput, 2);
            setValue2(serializedValue);
            return;
          }
        }

        if (ValidarCarecteresEspeciais.test(Mask[i])) {
          valor += Mask[i];
          valor += valueInput[i].replace(/[^0-9]/g, '') || '';
        } else {
          valor += valueInput[i].replace(/[^0-9]/g, '') || '';
        }
      }

      setValue2(valor);
      return;
    }
    setValue2(valueInput);
  }

  return (
    <FilterContainer>
      {/* Header com título, dropdown e botão de remover */}
      <FilterHeader>
        <FilterTitleRow>
          <FilterTitle>{filter.des_nome}</FilterTitle>
          <ConditionDropdown
            value={condition}
            onChange={(e) => setCondition(Number(e.target.value))}
          >
            {options.map((opt) => (
              <option key={opt.cod_condicao} value={opt.cod_condicao}>
                {opt.description}
              </option>
            ))}
          </ConditionDropdown>
        </FilterTitleRow>
      </FilterHeader>

      {/* Campos de entrada de valor */}
      {condition !== naoPreenchido && condition !== preenchido && (
        <FilterRow>
          <InpuTypeString
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              onChangeInput(e);
            }}
            value={value}
            id={filter.index}
            type="string"
            step="0.1"
            placeholder="Digite o valor..."
          />

          {isMulti && (
            <>
              <BetweenLabel>e</BetweenLabel>
              <InpuTypeString
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  onChangeInput2(e)
                }
                value={value2}
                type="string"
                placeholder="Digite o segundo valor..."
              />
            </>
          )}
        </FilterRow>
      )}

      {/* Botão de Atualizar */}
      <FullWidthButton>
        <CustomButtonNovo
          style={{ backgroundColor: ValidateInputs() ? '#dcdfe0' : '#0052CC' }}
          disabled={ValidateInputs()}
          type="button"
          onClick={handleSetValueFiltro}
          label="Atualizar"
        />
      </FullWidthButton>
    </FilterContainer>
  );
};

export default TypeDecimal;
